import React from 'react';
import { Link } from 'react-router-dom';
import car from '../../../assets/images/car.png';
import './HomeBanner.css';

const HomeBanner = () => {
    return (
        <div className="container home-banner">
            <div className="row">
                <div className="col-lg-6">
                    <h1 className='banner-title'>Premium <br /> Car Next <br /> To Your Door</h1>
                    <p className='banner-details'>Don't deny yourself the pleasure of <br /> driving the best premium cars from <br /> around the world here and now</p>
                    <Link to='/cars'><button className='banner-btn'>Get Your Car</button></Link>
                </div>
                <div className="col-lg-6">
                    <img style={{ width: '100%', marginTop: '70px' }} src={car} alt="" />
                </div>
            </div>
        </div>
    );
};

export default HomeBanner;